import { StateCreator } from 'zustand';

export interface PollingOptions<T> {
    id: string;
    apiCall: () => Promise<T>;
    interval?: number;
    onSuccess: (data: T) => void;
    onError: (error: any) => void;
}

export interface GenericPollerSlice {
    pollers: Record<string, NodeJS.Timeout>;
    startPolling: <T>(options: PollingOptions<T>) => void;
    stopPolling: (id: string) => void;
}

export const createGenericPollerSlice: StateCreator<GenericPollerSlice, [], [], GenericPollerSlice> = (set, get) => ({
    pollers: {},
    startPolling: <T>({ id, apiCall, interval = 1000, onSuccess, onError }: PollingOptions<T>) => {
        const { pollers } = get();
        if (pollers[id]) {
            clearInterval(pollers[id]);
        }
        const fetchData = async () => {
            try {
                const data = await apiCall();
                onSuccess(data);
            } catch (error) {
                onError(error);
            }
        };

        // Initial fetch
        fetchData();
        const timer = setInterval(fetchData, interval);
        set((state) => ({
            pollers: {
                ...state.pollers,
                [id]: timer
            }
        }));
    },

    stopPolling: (id: string) => {
        const { pollers } = get();
        if (pollers[id]) {
            clearInterval(pollers[id]);
            const { [id]: _, ...remaining } = pollers;
            set(() => ({
                pollers: remaining
            }));
        }
    }
});
